import { render, staticRenderFns } from "./PodCast.vue?vue&type=template&id=04a7ceae&"
import script from "./PodCast.vue?vue&type=script&lang=js&"
export * from "./PodCast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports